export default "__VITE_ASSET__BrQV8ZTO__"